<p class="ibk-description" *ngIf="isClient">
  Valida tu identidad como representante legal
</p>
<div class="ba-field-group pl-15-porc">
  <b>{{getTextCapitalize(firstName)}}</b>
</div>
<div class="ba-field-group pl-15-porc">
  <span>
    Ingresa el c&oacute;digo de verificaci&oacute;n enviado a <span class="text-lower">{{emailSelectedOtp |
      obfuscateOtpEmail:'TWO'}}.</span>
  </span>
</div>
<div class="ba-field-group pl-15-porc" formGroupName="codeOtp">
  <ibk-input-group class="span-2">
    <ibk-input class="field input-with" char-filter="^\d*$">
      <input placeholder="Ingrese Código" class="field" type="password" formControlName="code" name="code"
        maxlength="6" />
    </ibk-input>
  </ibk-input-group>
</div>
<ibk-toast *ngIf="showValidationCodeOtpIncorrect" type="ERROR">
  El código ingresado es incorrecto o no existe.
</ibk-toast>
<ibk-button class="pl-15-porc">
  <a href="#" [ngClass]="disabledBtnSendCode?'isDisabledBtn':'ibk-link'" (click)="returnSendCode($event)"> A&uacute;n no
    recibo el c&oacute;digo </a>
</ibk-button>

<ibk-button class="ba-action" [loading]="isLoading">
  <button [disabled]="disabledBtnSendCode? disabledBtnSendCode : codeOtpForm.invalid" id="validation-code-otp-step"
    class="ibk-btn ibk-btn--min-width ibk-btn--primary ba-btn" (click)="goToConfiguration()">
    Siguiente
  </button>
</ibk-button>
<ibk-toast *ngIf="disabledBtnSendCode" type="WARN">
  Contactate con la banca telef&oacute;nica.
</ibk-toast>
<br />
<br />
<hr class="ibk-separator" />
<div class="ba-field-group">
  <div class="footer-validation-otp">
    <a href="https://interbank.pe/solicitar/formulario/pedidos-reclamos/inicio?rfid=navegacion:footer:link"
      target="_blank"><img [src]="asset('assets/images/libro-reclamaciones.svg')" alt="libro reclamaciones"></a>
    <img [src]="asset('assets/images/compromiso.svg')" alt="compromiso">
  </div>
</div>
<div class="text-center">
  <span>
    Copyright 2020 - Todos los derechos reservados
  </span>
</div>
<div class="ctn-message d-flex" *ngIf="showMsgResendCode">
  <div class="body-message-validation">
    <div class="title-message" *ngIf="isPJ">
      <h2>¡Código reenviado!</h2>
    </div>
    <div class="title-message" *ngIf="!isPJ">
      Ingresa el c&oacute;digo que te hemos enviado a tu correo
    </div>
    <div class="title-message" *ngIf="isPJ">
      {{firstName}} ingresa el c&oacute;digo que enviamos a tu correo.
    </div>
  </div>
  <div class="ctn-btn-message">
    <button class="btn-message" (click)="closeMsgResendeCode()">
      <i class="material-icons">close</i>
    </button>
  </div>
</div>

<!-- <div class="ctn-message" *ngIf="showMsgResendCode">
  <div class="title-message">
    {{firstName}} ingresa el c&oacute;digo que enviamos a tu correo.
  </div>
  <div class="ctn-btn-message">
    <button class="btn-message" (click)="closeMsgResendeCode()">
      <i class="material-icons">close</i>
    </button>
  </div>
</div> -->
